/**
 * Column IDs for Locates V2 Results table
 */
export type LocatesV2ColumnId =
    | 'account'
    | 'createdTime'
    | 'symbol'
    | 'borrowStatus'
    | 'rejectReason'
    | 'quantity'
    | 'price'
    | 'priceChange5m'
    | 'percentOfPrice'
    | 'totalCost'
    | 'provider'
    | 'status'
    | 'selectedProvider'
    | 'actions'
    | 'autoAccept'
    | 'orderId'
    | 'offerId'
    | 'lastUpdateTime'
    | 'clientTrackingId';

/**
 * Default column widths in pixels
 */
export const DEFAULT_COLUMN_WIDTHS: Record<LocatesV2ColumnId, number> = {
    account: 96,
    createdTime: 96,
    symbol: 64,
    borrowStatus: 112,
    rejectReason: 128,
    quantity: 80,
    price: 80,
    priceChange5m: 96,
    percentOfPrice: 96,
    totalCost: 96,
    provider: 80,
    status: 80,
    selectedProvider: 96,
    actions: 128,
    autoAccept: 96,
    orderId: 128,
    offerId: 128,
    lastUpdateTime: 96,
    clientTrackingId: 128,
};

/**
 * Default column order
 */
export const DEFAULT_COLUMN_ORDER: LocatesV2ColumnId[] = [
    'account',
    'createdTime',
    'symbol',
    'borrowStatus',
    'rejectReason',
    'quantity',
    'price',
    'priceChange5m',
    'percentOfPrice',
    'totalCost',
    'provider',
    'status',
    'selectedProvider',
    'autoAccept',
    'orderId',
    'offerId',
    'lastUpdateTime',
    'clientTrackingId',
    'actions',
];

/**
 * Column display labels
 */
export const COLUMN_LABELS: Record<LocatesV2ColumnId, string> = {
    account: 'Account',
    createdTime: 'Created Time',
    symbol: 'Symbol',
    borrowStatus: 'Borrow Status',
    rejectReason: 'Reject Reason',
    quantity: 'Quantity',
    price: 'Price ($)',
    priceChange5m: 'Price Change 5m',
    percentOfPrice: '% of Price',
    totalCost: 'Total Cost ($)',
    provider: 'Provider',
    status: 'Status',
    selectedProvider: 'Selected Provider',
    actions: 'Actions',
    autoAccept: 'Auto Accept',
    orderId: 'Order ID',
    offerId: 'Offer ID',
    lastUpdateTime: 'Last Update Time',
    clientTrackingId: 'Client Tracking ID',
};

/**
 * Column min/max widths (optional constraints)
 */
export const COLUMN_MIN_WIDTHS: Record<LocatesV2ColumnId, number> = {
    account: 60,
    createdTime: 60,
    symbol: 60,
    borrowStatus: 60,
    rejectReason: 60,
    quantity: 60,
    price: 60,
    priceChange5m: 60,
    percentOfPrice: 60,
    totalCost: 60,
    provider: 60,
    status: 60,
    selectedProvider: 60,
    actions: 100,
    autoAccept: 60,
    orderId: 100,
    offerId: 100,
    lastUpdateTime: 60,
    clientTrackingId: 100,
};

export const COLUMN_MAX_WIDTHS: Record<LocatesV2ColumnId, number> = {
    account: 1200,
    createdTime: 1200,
    symbol: 1200,
    borrowStatus: 1200,
    rejectReason: 1200,
    quantity: 1200,
    price: 1200,
    priceChange5m: 1200,
    percentOfPrice: 1200,
    totalCost: 1200,
    provider: 1200,
    status: 1200,
    selectedProvider: 1200,
    actions: 1200,
    autoAccept: 1200,
    orderId: 1200,
    offerId: 1200,
    lastUpdateTime: 1200,
    clientTrackingId: 1200,
};

/**
 * Default column visibility (all visible by default except less commonly used ones)
 */
export const DEFAULT_COLUMN_VISIBILITY: Record<LocatesV2ColumnId, boolean> = {
    account: true,
    createdTime: true,
    symbol: true,
    borrowStatus: true,
    rejectReason: true,
    quantity: true,
    price: true,
    priceChange5m: true,
    percentOfPrice: true,
    totalCost: true,
    provider: true,
    status: true,
    selectedProvider: true,
    actions: true,
    autoAccept: true,
    orderId: true,
    offerId: true,
    lastUpdateTime: true,
    clientTrackingId: true,
};
